import { useCallback, useState } from 'react';
import SecaoCanais from '@/components/configuracoes/SecaoCanais';
import SecaoAtendimentoAuto from '@/components/configuracoes/SecaoAtendimentoAuto';
import SecaoAtendimento from '@/components/configuracoes/SecaoAtendimento';
import SecaoCaptacao from '@/components/configuracoes/SecaoCaptacao';
import SecaoAgenda from '@/components/configuracoes/SecaoAgenda';
import SecaoMotivos from '@/components/configuracoes/SecaoMotivos';
import SecaoOrigens from '@/components/configuracoes/SecaoOrigens';
import SecaoClinica from '@/components/configuracoes/SecaoClinica';
import SecaoDesempenho from '@/components/configuracoes/SecaoDesempenho';

/**
 * Configurações da clínica — só do gestor.
 *
 * Virou ABAS porque a página cresceu: empilhadas, as seções somavam sete
 * cartões e a última ficava a três rolagens do topo. Cada aba é uma decisão
 * diferente (a via técnica, o relógio, o estilo das mensagens) e raramente se
 * mexe em duas na mesma sessão.
 *
 * Etiquetas e respostas rápidas SAÍRAM daqui (23/ago) para Preferências, dentro
 * de cada setor: quem descobre que falta uma etiqueta é quem está atendendo.
 */

const ABAS = [
  {
    id: 'canais',
    rotulo: 'Canais',
    Secao: SecaoCanais,
    ajuda: 'Números de WhatsApp e conexão por QR Code.',
  },
  {
    id: 'automatico',
    rotulo: 'Horário e mensagens',
    Secao: SecaoAtendimentoAuto,
    ajuda: 'Quando a clínica atende e o que sai sozinho em cada número.',
  },
  {
    id: 'atendimento',
    rotulo: 'Atendimento',
    Secao: SecaoAtendimento,
    ajuda: 'Como as mensagens da equipe saem para o cliente.',
  },
  {
    id: 'captacao',
    rotulo: 'Captação',
    Secao: SecaoCaptacao,
    ajuda: 'Regras que preenchem o procedimento do lead pela primeira mensagem, e os links dos anúncios.',
  },
  {
    id: 'agenda',
    rotulo: 'Agenda',
    ajuda: 'Horários de avaliação por dia, vagas e dias bloqueados.',
    Secao: SecaoAgenda,
  },
  {
    id: 'motivos',
    rotulo: 'Motivos do funil',
    ajuda: 'Por que não agendou e por que não fechou — as listas que o funil exige.',
    Secao: SecaoMotivos,
  },
  {
    id: 'origens',
    rotulo: 'Origens do lead',
    ajuda: 'De onde os leads vêm — a lista dos selects e as palavras que a primeira mensagem denuncia.',
    Secao: SecaoOrigens,
  },
  {
    // ★★ WO lote 3a — o que decide como os Indicadores de Performance contam.
    id: 'desempenho',
    rotulo: 'Desempenho',
    Secao: SecaoDesempenho,
    ajuda: 'Expediente (o sábado vale metade), telefones da equipe a excluir das contagens e a janela das taxas.',
  },
  {
    id: 'clinica',
    rotulo: 'Clínica',
    Secao: SecaoClinica,
    ajuda: 'Dados da clínica: o nome do sistema de gestão que aparece nas telas.',
  },
];

export default function ConfiguracoesPage() {
  const [aba, setAba] = useState(ABAS[0].id);
  /**
   * ★★ 02/11/2026 — a seção avisa quando tem alteração NÃO salva (hoje só a Agenda: a grade e as
   * repetições ainda dependem de "Salvar grade"). ⚠ Trocar de aba DESMONTA a seção e perde o
   * que não foi salvo — então pergunta antes. ⚠ O clique noutro item do MENU não passa por aqui
   * (o `BrowserRouter` não tem `useBlocker`); por isso os bloqueios de dia gravam na hora.
   */
  const [sujo, setSujo] = useState(false);
  const aoMudarSujo = useCallback((v) => setSujo(Boolean(v)), []);
  const trocarDeAba = (id) => {
    if (id === aba) return;
    if (sujo && !window.confirm('Há alterações não salvas na agenda. Sair sem salvar?')) return;
    setSujo(false);
    setAba(id);
  };
  const atual = ABAS.find((a) => a.id === aba) ?? ABAS[0];
  const { Secao } = atual;

  return (
    <div className="pagina">
      <header className="pagina-cabecalho">
        <h1>Configurações da clínica</h1>
        <p className="painel-sub">{atual.ajuda}</p>
      </header>

      {/* `role="tablist"` e as setas do teclado ficam de fora de propósito: são
          botões que trocam o conteúdo abaixo, e o padrão ARIA completo de abas
          exigiria gerenciar foco por conta própria. Botões simples já são
          alcançáveis por Tab e anunciam o estado por `aria-pressed`. */}
      <nav className="abas" aria-label="Seções das configurações">
        {ABAS.map((a) => (
          <button
            key={a.id}
            type="button"
            className={a.id === aba ? 'aba ativa' : 'aba'}
            onClick={() => trocarDeAba(a.id)}
            aria-pressed={a.id === aba}
          >
            {a.rotulo}
          </button>
        ))}
      </nav>

      {/* Só a seção da aba é montada. Montar as três e esconder duas por CSS
          manteria três assinaturas do Firestore abertas para nada. */}
      <Secao aoMudarSujo={aoMudarSujo} />
    </div>
  );
}
